// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-error-wrapper[data-v-7ba5bd90] {\n  position: relative;\n}\n.app-error-wrapper__logo[data-v-7ba5bd90] {\n  position: absolute;\n  top: 32px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  z-index: 1;\n}\n", ""]);
// Exports
module.exports = exports;
